import React, { MouseEvent, useRef } from "react";
import classNames from "classnames";
import styles from "./ItemButton.module.scss";
import right from "@/assets/right.svg";
import { Icon } from "@/elements-react/fix-icon";
// import { useTranslation } from 'react-i18next';
// import { useServices } from '@/hooks/useServices';

export type ItemButtonProps = {
  action?: "button" | "link" | "link-router-ignore";
  href?: string | null;
  icon?: string | null;
  title: string;
  sub?: string | null;
  count?: number;
  schema?: "line" | "column";
  className?: string;
  active?: boolean;
  onClick?: (e: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>, detail: { target: HTMLElement | null }) => void;
  onHover?: (e: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>, detail: { target: HTMLElement | null }) => void;
};

export const ItemButton: React.FC<ItemButtonProps> = ({
  action = "button",
  href = null,
  icon = null,
  title,
  sub = null,
  count,
  schema = "line",
  className,
  active = false,
  onClick,
  onHover,
}) => {
  // const { t } = useTranslation();
  // const services = useServices();
  const itemRef = useRef<HTMLButtonElement & HTMLAnchorElement & HTMLDivElement>(null);

  const iconEnabled = typeof icon === "string" && icon !== "empty";
  const countEnabled = typeof count === "number";
  const subEnabled = typeof sub === "string" && sub.length > 0;

  const handleClick = (event: MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => {
    onClick?.(event, { target: itemRef.current });
  };

  const handleHover = (event: MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => {
    event.stopPropagation();
    onHover?.(event, { target: itemRef.current });
  };

  const content = (
    <>
      <div className={classNames(styles.left, 'left')}>{iconEnabled && icon && <Icon className={styles.icon} src={icon} />}</div>
      <div className={classNames(styles.center, 'center')}>
        <label className={styles.title}>{title}</label>
        {subEnabled && <label className={styles.sub}>{sub}</label>}
        {countEnabled && <label className={styles.count}>{count}</label>}
      </div>
      <div className={classNames(styles.right, 'right')}>
        <Icon className={styles.arrow} src={right} />
      </div>
    </>
  );

  const rootClass = classNames(
    styles.item,
    styles[schema],
    {
      [styles.icon]: !!icon,
      [styles.active]: active,
    },
    className,
  );

  if (action === "button") {
    return (
      <button ref={itemRef as any} className={rootClass} onClick={handleClick} onMouseEnter={handleHover} type="button">
        {content}
      </button>
    );
  }
  if (action === "link-router-ignore") {
    return (
      <a ref={itemRef as any} href={href ?? "#"} className={rootClass} data-router-ignore="true" onClick={handleClick} onMouseEnter={handleHover}>
        {content}
      </a>
    );
  }
  // action === 'link'
  return (
    <a ref={itemRef as any} href={href ?? "#"} className={rootClass} onClick={handleClick} onMouseEnter={handleHover}>
      {content}
    </a>
  );
};
